import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpBackend from 'i18next-http-backend'
import { config } from './config'

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: config?.backend?.language, // idioma por defecto
    fallbackLng: config?.backend?.language,
    ns: ['index', 'home', 'menu', 'map', 'footer'],
    defaultNS: 'index',
    backend: {
      loadPath: `${config?.backend?.basePath}/locales/{{lng}}/{{ns}}.json` // ruta para cargar los archivos
    },
    interpolation: { escapeValue: false },
    react: {
      useSuspense: false
    }/*,
    debug: true */
  })

export default i18n
